import {
  Suspense, lazy, useCallback, useEffect, useState,
} from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import PersonasIcon from 'Components/common/assets/svgIcons/PersonasIcon';
import {
  boxShadow, maxMobile, maxWidth, primaryFont, retina, wMedium,
} from 'Utils/utilsStyle';
import styled from 'styled-components';

const PersonasDrawerBody = lazy(() => import('Components/people/components/PersonasDrawerBody'));

const Box = styled.span`
 color:#000;
 margin: 0px 0px 0px 12px;
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 height: 70px;
 width: 70px;
 background-color: #fff;
 border-radius: 8px 0px 0px 8px;
 box-shadow: ${boxShadow};
 transition: 0.1s ease all;
 position: fixed;
 top: 225px;
 right: 0px;
 z-index: 1;
 padding: 10px 0px 0px 0px;
 cursor: pointer;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    border-radius: 5px 0px 0px 5px;
    height: 55px;
    width: 60px;
    top: 205px;
    padding: 0px;
  }
  @media all and (max-width: ${maxMobile}) {
    top: 163px;
    height: 35px;
    width: 35px;
  }
 &.drawerBoxOpen {
  right: 530px;
  transition: all .3s;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    right: 380px;
  }
 }
  svg {
    height: 22px;
    width: auto;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      width: 22px;
    }
    @media all and (max-width: ${maxMobile}) {
      width: 17px;
      height: 14px;
    }
    path {
      opacity: 0.7;
    }
  }
`;

const Wrapper = styled.div`
  position: relative;
`;

const Personas = styled.p`
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 0px;
  font-weight: ${wMedium};
  letter-spacing: 0.3px;
  font-family: ${primaryFont};
  @media all and (max-width:${maxWidth}), ${retina} {
    font-size: 10px;
    margin-top: 0px;
  }
  @media all and (max-width: ${maxMobile}){
    font-size: 7px;
  }
`;

const DrawerPersonas = function DrawerPersonas() {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setVisible(false);
  }, [location]);

  const toggle = useCallback(() => {
    setMounted(true);
    setVisible((prev) => !prev);
  }, []);

  const prefetch = useCallback(() => setMounted(true), []);

  return (
    <Wrapper>
      <Box
        onClick={toggle}
        onMouseEnter={prefetch}
        onFocus={prefetch}
        className={classNames('boxDoor', 'personaBoxDoor', { drawerBoxOpen: visible })}
      >
        <PersonasIcon />
        <Personas>Personas</Personas>
      </Box>
      {mounted ? (
        <Suspense fallback={null}>
          <PersonasDrawerBody visible={visible} toggle={toggle} />
        </Suspense>
      ) : null}
    </Wrapper>
  );
};

export default DrawerPersonas;
